import { render, staticRenderFns } from "./_base-single-order-receipt.vue?vue&type=template&id=60c12721&scoped=true"
import script from "./_base-single-order-receipt.vue?vue&type=script&lang=js"
export * from "./_base-single-order-receipt.vue?vue&type=script&lang=js"
import style0 from "./_base-single-order-receipt.vue?vue&type=style&index=0&id=60c12721&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c12721",
  null
  
)

export default component.exports